import { ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ScrollStrategy } from '@angular/cdk/overlay';
import { Direction } from '@angular/cdk/bidi';

export type DialogRole = 'dialog' | 'alertdialog';

export type OverlayType = 'modal' | 'bottomSheet' | 'rightSheet';

export interface DialogPosition {
  /** Override for the dialog's top position. */
  top?: string;

  /** Override for the dialog's bottom position. */
  bottom?: string;

  /** Override for the dialog's left position. */
  left?: string;

  /** Override for the dialog's right position. */
  right?: string;
}

export class GritOverlayConfig<D = any> {
  viewContainerRef?: ViewContainerRef;
  id?: string;
  role?: DialogRole = 'dialog';

  disableClose?: boolean = false;

  overlayType?: OverlayType = 'modal';
  autoFocus?: boolean = true;
  restoreFocus?: boolean = true;

  data?: D | null = null;
  /** Position overrides. */
  position?: DialogPosition;
  ariaDescribedBy?: string | null = null;
  ariaLabelledBy?: string | null = null;
  ariaLabel?: string | null = null;

  /** Required attributes cdk Overlay to function */
  scrollStrategy?: ScrollStrategy;
  direction?: Direction;
  closeOnNavigation?: boolean = true;
  hasBackdrop?: boolean = true;
  backdropClass?: string = '';
  componentFactoryResolver?: ComponentFactoryResolver;

  /** Width of the dialog. */
  maxWidth?: string = '';

  /** Height of the dialog. */
  minHeight?: string = '';

  /** Custom class for the overlay pane. */
  panelClass?: string | string[] = '';
}
